import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import Classes, { ACHBatch } from "model";

export default function CaptureOffsetAccount(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const effectiveDate = BCMSDate.init().nextBusinessDay().nextBusinessDay();
    const secCode = ACHBatch.getSelectedSecCodeByBranding();
    const { branding } = useModel() ?? {};
    const { options } = branding ?? {};
    const hasACHFromSection = options.ach_from_abi22 === "true";
    const hasACHCCDNonConsumerCredit = options.nonconsumer_credit_abi22 === "true";
    
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update([ "oneTimeACHPayment", "secCode" ], secCode)
    .update([ "oneTimeACHPayment", "scheduleType" ], "future dated")
    .update([ "oneTimeACHPayment", "effectiveDate" ], effectiveDate)
    .update([ "oneTimeACHPayment", "companyEntryDescription" ], hasACHCCDNonConsumerCredit ? "ACH PMT" : "PAYROLL")
    .update([ "oneTimeACHPayment", "company" ], "0")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "showSecCode", "isActive" ], true)
    .update([ "offsetAccountSelectIsActive", "isActive" ], true)
    .submit();

    if(!hasACHFromSection) {
        const message = `This capture is only shown when ABI22 branding option "One-Time ACH/Template - ACH From Section" is set to "Yes".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}